import React from "react";
import { CreateProposalHeaderProjectGallery } from "./create-proposal-header--project-gallery";
import { ProjectImage } from "./props";

interface CreateProposalProjectGalleryPopupProps {
    title?: string
    projectGalleryPopup: {
        open: boolean;
        projectDetails?: {
            resImages?: any[];
            projectName?: string;
            _id?: string;
            imagePath?: string;
        } | null;
    }
    selectedProjectImages: ProjectImage[];
    setIsEdited: React.Dispatch<React.SetStateAction<boolean>>;
    setProjectGalleryPopup: React.Dispatch<React.SetStateAction<{
        open: boolean;
        projectDetails?: {
            resImages?: any[];
            projectName?: string;
            _id?: string;
            imagePath?: string;
        } | null;
    }>>
    setProjectSelectedImages: React.Dispatch<React.SetStateAction<ProjectImage[]>>;
}

export function CreateProposalProjectGalleryPopup({ projectGalleryPopup,
    selectedProjectImages,
    setIsEdited,
    title,
    setProjectGalleryPopup,
    setProjectSelectedImages }: CreateProposalProjectGalleryPopupProps) {

    return (
        <>
            <div
                className={`detail-poupup  position-fixed top-0 w-100 h-100 overflow-auto in `}
                style={{ zIndex: 1051 }}
                id="galleryPopup"
            >
                <CreateProposalHeaderProjectGallery
                    title={title}
                    setProjectGalleryPopup={setProjectGalleryPopup}
                />

                <div className="py-4 px-5">
                    <div className="row img-uploader-gallery gutter-5 py-1">
                        {projectGalleryPopup?.projectDetails?.resImages?.map((image: ProjectImage, index: number) => {
                            return (
                                <div
                                    className="col-sm-3"
                                    key={index}
                                    style={{ marginBottom: "10px" }}
                                >
                                    <div className="item-img-upload overflow-hidden position-relative w-100">
                                        <img
                                            src={image.projectImage}
                                            alt="img"
                                            className="img-fluid h-100 w-100"
                                        />
                                        {/* <span className="strap d-block position-absolute text-uppercase text-white font-weight-semibold">
                              {image?.media?.originalname}
                              </span> */}
                                        <span className="checkbox d-flex justify-content-center align-items-center position-absolute rounded-circle">
                                            <input
                                                type="checkbox"
                                                name="checkprop-create-proposal"
                                                id={`item_${index}`}
                                                checked={selectedProjectImages.some((item) => +item.projectImageID === +image.projectImageID)}
                                                onClick={() => {
                                                    setIsEdited(true);
                                                    if (selectedProjectImages.some((item) => +item.projectImageID === +image.projectImageID)) {
                                                        setProjectSelectedImages(prev => prev.filter(img => +img.projectImageID !== +image.projectImageID))
                                                    } else {
                                                        setProjectSelectedImages(prev => [
                                                            ...prev,
                                                            {
                                                                projectId: projectGalleryPopup?.projectDetails?._id || '',
                                                                projectName: projectGalleryPopup?.projectDetails?.projectName || '',
                                                                imagePath: projectGalleryPopup?.projectDetails?.imagePath || '',
                                                                projectImageName: image.projectImageName,
                                                                projectImage: image.projectImage,
                                                                projectImageID: image.projectImageID,
                                                                projectID: image.projectID,
                                                                projectImageTitle: image?.projectImageTitle || '',
                                                                projectImageAltTag: image?.projectImageAltTag || '',
                                                                imageCatID: Number(image?.imageCatID) || 0,
                                                                imageCatType: image?.imageCatType || ''
                                                            }
                                                        ])
                                                    }
                                                }}
                                            />
                                            <label htmlFor={`item_${index}`}></label>
                                        </span>
                                    </div>
                                </div>
                            );
                        })}
                        <div className="col-sm-12 mt-5 text-right">
                            <button
                                className="btn btn-primary font-normal font-weight-semibold px-4 py-2"
                                style={{ height: "40px", borderRadius: "4px" }}
                                onClick={() => setProjectGalleryPopup({ open: false, projectDetails: null })}
                            >
                                Add Photo
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop fade show" style={{ zIndex: 1050 }}></div>
        </>
    );
}
